<template>
  <div class="panel">
    <a class="collapse-btn d-flex align-items-center justify-content-between" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="true" aria-controls="collapseExample" v-on:click="collapseClick">
      <div class="btn-label d-flex align-items-center">
        <div class="icon d-flex align-items-center">
          <img src="../../assets/info-icon.svg" alt="" />
        </div>
        <p class="mb-0 title">Helpful Tips for Audio</p>
      </div>
      <img src="../../assets/arrow-up.svg" class="arrow-icon" alt="" />
    </a>
    <div class="collapse collapse-content show" id="collapseExample">
      <p><span>•</span>  Select a place that is quiet</p>
      <p><span>•</span>  You will get a chance to re-record any response before you submit it</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "HelfullTipsVideo",
  data() {
    return {};
  },
  methods: {
    collapseClick() {
      setTimeout(() => {
        this.$helpers.resizeIframeEvent();
      }, 800);
    },
  },
};
</script>
<style lang="scss" scoped>
.panel {
  .collapse-btn {
    background: #ffffff;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 0px 0px;
    padding: 14px 16px;
    text-decoration: none;
    position: relative;
    z-index: 1;

    .btn-label {
      .icon {
        margin-right: 8px;
      }
      .title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #56657f;
      }
    }

    &[aria-expanded="true"] {
      .arrow-icon {
        transform: rotateZ(0deg);
      }
    }

    &[aria-expanded="false"] {
      .arrow-icon {
        transform: rotateZ(180deg);
      }
    }
  }
  .collapse-content {
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    padding: 24px 10px 24px 16px;
    text-align: left;

    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
      margin-bottom: 8px;
    }
  }
}
</style>
